module.exports = __webpack_public_path__ + "static/media/icon_favorite.ec435c07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_favorite.svg
// module id = 711
// module chunks = 0